export default __webpack_public_path__ + "static/media/GasLift1.0756bcd1.png";